import React, { ReactNode } from 'react';
import Portal from '../portal/portal';
import './loading.css';

export interface ILoadingProps {
  title?: string;
  icon?: ReactNode | JSX.Element;
}

export const Loading = ({
  title = 'Carregando',
  icon = <div className="loader-default" data-cy="LoadingIcon"></div>,
}: ILoadingProps) => {
  return (
    <Portal name="loading">
      <div className="box-loading" data-cy="LoadingContainer">
        <div className="box-load">
          {icon}
          {title ? (
            <h5 data-cy="LoadingText" style={{ userSelect: 'none' }}>
              {title}
            </h5>
          ) : null}
        </div>
      </div>
    </Portal>
  );
};
